import { render } from "./CIS-Resource-PagedListing-BenchmarkExcerpt.vue?vue&type=template&id=b4ab10e4&scoped=true"
import script from "./CIS-Resource-PagedListing-BenchmarkExcerpt.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-PagedListing-BenchmarkExcerpt.vue?vue&type=script&lang=js"

import "./CIS-Resource-PagedListing-BenchmarkExcerpt.vue?vue&type=style&index=0&id=b4ab10e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ab10e4"]])

export default __exports__